export default __webpack_public_path__ + "static/media/Warlord's Great Shield.483861c4.jpg";